export default __webpack_public_path__ + "styles/main.773ef1990319444627f350a0c5770020.css";